/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ToolHardHammersIcon16Light } from './ToolHardHammersIcon16Light';
import { ToolHardHammersIcon16Regular } from './ToolHardHammersIcon16Regular';
import { ToolHardHammersIcon16Solid } from './ToolHardHammersIcon16Solid';
import { ToolHardHammersIcon20Light } from './ToolHardHammersIcon20Light';
import { ToolHardHammersIcon20Regular } from './ToolHardHammersIcon20Regular';
import { ToolHardHammersIcon20Solid } from './ToolHardHammersIcon20Solid';
import { ToolHardHammersIcon24Regular } from './ToolHardHammersIcon24Regular';
import { ToolHardHammersIcon24Solid } from './ToolHardHammersIcon24Solid';
import { ToolHardHammersIcon32Regular } from './ToolHardHammersIcon32Regular';
import { ToolHardHammersIcon64Regular } from './ToolHardHammersIcon64Regular';
var sizes = {
    16: {
        light: ToolHardHammersIcon16Light,
        regular: ToolHardHammersIcon16Regular,
        solid: ToolHardHammersIcon16Solid,
    },
    20: {
        light: ToolHardHammersIcon20Light,
        regular: ToolHardHammersIcon20Regular,
        solid: ToolHardHammersIcon20Solid,
    },
    24: {
        regular: ToolHardHammersIcon24Regular,
        solid: ToolHardHammersIcon24Solid,
    },
    32: {
        regular: ToolHardHammersIcon32Regular,
    },
    64: {
        regular: ToolHardHammersIcon64Regular,
    },
};
export var ToolHardHammersIcon = forwardRef('ToolHardHammersIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
